export default __webpack_public_path__ + "images/e499b6a11effecf8279b9f080de6ba74-orchestra.webp";